export default __webpack_public_path__ + "static/media/ticket27.e8002925.jpg";